module.exports = __webpack_public_path__ + "img/lbc-loading-.5fe9faef.gif";